import { useMutation, useQueryClient } from "@tanstack/react-query";
import { setPostFtux } from "api/set-post-ftux";

export const useSetPostFtux = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: setPostFtux,
    onSuccess: () => {
      // Ensure the user profile (and other queries) are refreshed so ftuxComplete is up to date
      queryClient.invalidateQueries();
    },
  });
};
